import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AuthLayout: FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return children;
};

export default AuthLayout;
